/* eslint-disable prefer-arrow/prefer-arrow-functions */
/* eslint-disable import/no-cycle */
/* eslint-disable no-else-return */
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import ipRegex from 'ip-regex';
import { Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { OperatorService } from 'src/app/modules/administration/services/operator.service';
import { date, dateToNgb, getMoment } from 'src/app/modules/core/services/datetime.service';
import { environment } from 'src/environments/environment';
import { LanguageService } from '../services/parameters';
import { objectPathExists, parseTag } from '../services/utils/utilities';

/** *
 * name Control validators funcs
 */
export function validateStartWithSpecialCharOrSpace(name: string): boolean {
  return /(^\W)/.test(name);
}

/** *
 * name Control validators funcs
 */
export function validateTwoSpaceBetween(name: string): boolean {
  return /([^a-zA-ZñÑáéíóúÁÉÍÓÚ0-9]+([\s{2,}]))/.test(name);
}

/** *
 * name Control validators funcs
 */
export function validateTwoSpecialChars(name: string): boolean {
  return /([@!¡¿=/%?$%"´¨;,.+*~|°¬<>#&_-]){2,}/.test(name);
}

export function validateNoSpecialChars(name: string): boolean {
  return /([@!¡()¿=/%?$%"´¨;,.+*~|°¬<>#&_-]){1,}/.test(name);
}

export function validateNoStartOrEndWithDot(name: string): boolean {
  // Asegurarse que no hay puntos consecutivos, ni punto al inicio, ni punto al final
  return /^(?!.*\.\.)(?!.*\.$)(?!^\.)[a-zA-Z0-9]+(?:\.[a-zA-Z0-9]+)*$/.test(name);
}

export class CustomValidates {
  public static readonly TAG_PREFIX = '451';
  public static subscriptions: Subscription[] = [];
  public static _operatorService: OperatorService;

  constructor(public _languageService: LanguageService) {}
  /**
   * Validates that key letter , number and caracter - _ @ .
   *
   * @param $event KeyboardEvent
   */
  public validateEmailFormat($event: KeyboardEvent): void {
    const REGEX_LOGIN = '[^a-zA-ZÀ-ÿ0-9-_@.]';
    if ($event.key.match(REGEX_LOGIN) && $event.key !== 'Backspace') {
      $event.preventDefault();
    }
  }

  /**
   * Validates that key letter and number.
   *
   * @param $event KeyboardEvent
   */
  public validatePasswordFormat($event: KeyboardEvent): void {
    const REGEX_PASSWORD = '[^a-zA-ZÀ-ÿ0-9]';
    if ($event.key.match(REGEX_PASSWORD) && $event.key !== 'Backspace') {
      $event.preventDefault();
    }
  }

  /**
   * Validates that key only letter
   *
   * @param $event KeyboardEvent
   */
  public validateNoStartOrEndWithDot($event: KeyboardEvent): void {
    const inputElement = $event.target as HTMLInputElement;
    const inputValue = inputElement.value;
    const containsDot = inputValue.includes('.');

    const shouldPrevent = validateNoStartOrEndWithDot(inputValue);
    if (shouldPrevent && containsDot && $event.key === '.') {
      $event.preventDefault();
    }
  }

  /**
   * Validates that key only letter
   *
   * @param $event KeyboardEvent
   */
  public validateOnlyLetter($event: KeyboardEvent): void {
    const REGEX_ONLYLETTER = '([^a-zA-Záéíóúa-zA-Záéíóú ])';
    if ($event.key.match(REGEX_ONLYLETTER) && $event.key !== 'Backspace') {
      $event.preventDefault();
    }
  }

  /**
   * Validates that key only number
   *
   * @param $event KeyboardEvent
   */
  public validateOnlyNumber($event: KeyboardEvent): void {
    const REGEX_ONLYNUMBER = '[^0-9]';
    if (RegExp(REGEX_ONLYNUMBER).exec($event.key) && $event.key !== 'Backspace') {
      $event.preventDefault();
    }
  }

  // Validates that key only number and letter
  public static validateIfMachineNameExists(existingMachines: any[], currentMachineId?: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const name = control.value?.trim().toLowerCase();
      if (!name) return null;

      const exists = existingMachines.some((m) => {
        const mName = m.name?.trim().toLowerCase();
        const isSameName = mName === name;
        const isDifferentMachine = m.machineId !== currentMachineId;
        return isSameName && isDifferentMachine;
      });

      return exists ? { nameExists: true, message: 'i020' } : null;
    };
  }

  public static validateIfMachineTagExists(machineList: any[], currentMachineId?: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const rawTag: string = control.value;
      if (!rawTag) return null;

      const normalizedTag = `451${rawTag.replace(/[^a-zA-Z0-9]/g, '')}`;

      const exists = machineList.some((m) => {
        const tagMatches = m.tagId?.toString() === normalizedTag;
        const isDifferentMachine = m.machineId !== currentMachineId;
        return tagMatches && isDifferentMachine;
      });

      return exists ? { tagExists: true, message: 'i021' } : null;
    };
  }

  // public static validateIfMachineTagExists(machineList: any[]): ValidatorFn {
  //   return (control: AbstractControl): ValidationErrors | null => {
  //     const rawTag: string = control.value;
  //     if (!rawTag) return null;

  //     // Normalizar: eliminar caracteres y agregar prefijo
  //     const normalizedTag = `451${rawTag.replace(/[^a-zA-Z0-9]/g, '')}`;

  //     const exists = machineList.some((m) => m.tag === normalizedTag || m.tagId === Number(normalizedTag));

  //     return exists ? { tagExists: true, message: 'i021' } : null;
  //   };
  // }

  public static validateOnlyNumberLabour($event: KeyboardEvent): void {
    const REGEX_ONLYNUMBER = '[^0-9]';
    if ($event.key.match(REGEX_ONLYNUMBER) && $event.key !== 'Backspace') {
      $event.preventDefault();
    }
  }

  /**
   * Validates that key only number and dot
   *
   * @param $event KeyboardEvent
   */
  public static validateNumberIP($event: KeyboardEvent): void {
    const REGEX_ONLYNUMBER_IP = '[^0-9]';
    if (
      $event.key.match(REGEX_ONLYNUMBER_IP) &&
      $event.key !== 'Backspace' &&
      $event.key !== 'Tab' &&
      $event.key !== 'ArrowLeft' &&
      $event.key !== 'ArrowRight' &&
      $event.key !== 'ArrowUp' &&
      $event.key !== 'ArrowDown' &&
      $event.key !== 'Delete'
    ) {
      $event.preventDefault();
    }
  }

  public static validateFormatIP(ip): boolean {
    const formatIP =
      /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

    if (ip.match(formatIP)) {
      return true;
    }
    return false;
  }

  public static errorIp(value: any, isRepeat: boolean): string {
    const isValidFormat = this.validateFormatIP(value);

    if (!isValidFormat) {
      if (value !== '') {
        return 'insert-correct-ip-format';
      }
    } else if (isRepeat) {
      return 'ip-used';
    }
    return null;
  }
  /**
   * Validates that key only number and dot
   *
   * @param $event KeyboardEvent
   */
  public static validateNumberMac($event: KeyboardEvent): void {
    const REGEX_ONLYNUMBER_MAC = '[^0-9a-fA-F:]';
    if ($event.key.match(REGEX_ONLYNUMBER_MAC) && $event.key !== 'Backspace') {
      $event.preventDefault();
    }
  }

  /**
   * Validates that key alfanumerics
   *
   * @param $event KeyboardEvent
   */
  public static validateAlfanumeric($event: KeyboardEvent): void {
    const REGEX_ALFANUMERIC = '([^a-zA-ZáéíóúÑa-zA-Záéíóúñ0-9 #&_-])';
    if ($event.key.match(REGEX_ALFANUMERIC) && $event.key !== 'Backspace') {
      $event.preventDefault();
    }
  }

  /**
   * Validates that key alfanumerics
   *
   * @param $event KeyboardEvent
   */
  public static validateAlfanumericToComputer($event: KeyboardEvent): void {
    const REGEX_ALFANUMERIC = '([^a-zA-ZáéíóúÑa-zA-Záéíóúñ0-9-])';
    if ($event.key.match(REGEX_ALFANUMERIC) && $event.key !== 'Backspace') {
      $event.preventDefault();
    }
  }

  /**
   * Get error Email
   */
  public getErrorEmail(control: AbstractControl): string {
    const email = control.get('email');
    if (!email.valid && email.errors.formatEmail) {
      const insertValidEmail = this._languageService.message('insert-valid-email');
      return insertValidEmail;
    }
    if (!email.valid && email.dirty && email.errors && email.errors.repeat) {
      const usedBy = this._languageService.message('used-email-by');
      return `${usedBy} : ${email.errors.emailUsedBy}`;
    }
    return '';
  }

  /**
   * Get error loginName Exist
   */
  public getErrorLoginName(control: AbstractControl): string {
    const login = control.get('loginName');

    if (!login.valid && login.dirty && login.errors && login.errors.repeat) {
      return `Este LoginName se encuentra en uso por: ${login.errors.loginUsedBy}`;
    }

    return null;
  }

  /**
   * Get error mtboxName Exist
   */
  public getErrorMtBoxName(control: AbstractControl): string {
    const mtboxName = control.get('inputMtbox');

    if (!mtboxName.valid && mtboxName.dirty && mtboxName.errors && mtboxName.errors.repeat) {
      return this._languageService.message('existing-mtbox');
    }

    return null;
  }

  /**
   * validate tag is correct
   *
   * @param control tag of Maintainers
   * @returns error message
   */
  public getErrorTagIsCorrect(control: AbstractControl): string {
    const tagInput = control.get('tag') || control.get('tagOperator');
    const incorrect = objectPathExists(tagInput, 'errors.incorrect', true);
    return incorrect ? 'Este n° de TAG se encuentra en uso' : null;
  }

  public getErrorSapIsCorrect(control: AbstractControl): { message: string; display: boolean } {
    const tagInput = control.get('sapNumber') || control.get('inputSap');
    const incorrect = objectPathExists(tagInput, 'errors.incorrect', true);
    return incorrect ? { message: 'Este n° de SAP se encuentra en uso', display: true } : { message: null, display: false };
  }

  /**
   * TODO ===> OperatorService injecctor doesn't works. TO FIX!!
   *
   * @param control to validate tag for operators if exist
   */
  public static validateTag(control: AbstractControl) {
    const tagInput = control.get('tag') || control.get('tagOperator');
    this.subscriptions.push(
      tagInput.valueChanges.pipe(distinctUntilChanged()).subscribe(async (value) => {
        if (value && value.indexOf('.') === -1 && value.length === 7) {
          value = parseTag(value);
          tagInput.setValue(value, { emitEvent: false });
        }
        if (value && value.length === 7) {
          value = this.TAG_PREFIX + value.replaceAll('.', '');
          this._operatorService
            .searchTagOperator(+value)
            .then((tag) => {
              if (tag && tag.length && tagInput.value) {
                tagInput.setErrors({ incorrect: true });
              } else {
                tagInput.setErrors(null);
              }
            })
            .catch(() => {
              tagInput.setErrors({ incorrect: true });
            });
        }
      }),
    );
  }

  public static validateHourAndDate: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const dateInput = control.get('dateInput');
    const time = control.get('time');

    const today = new Date();
    const hour = today.getHours();
    const minute = today.getMinutes();

    const hourActual = hour < 10 ? `0${hour}` : hour;
    const minuteActual = minute < 10 ? `0${minute}` : minute;

    const format = `${environment.dateFormatSystem} ${environment.timeFormat}`;
    const message = getMoment(dateInput.value, format).format(`${environment.dateFormatSystem}`);

    const dateSystem = date();
    const dateTransformToNgb = dateToNgb(dateSystem);
    let dateFormat = `${dateTransformToNgb.year}-`;
    dateFormat += dateTransformToNgb.month < 10 ? `0${dateTransformToNgb.month}-` : `${dateTransformToNgb.month}-`;
    dateFormat += dateTransformToNgb.day < 10 ? `0${dateTransformToNgb.day}` : dateTransformToNgb.day;

    if (dateFormat === message) {
      if (time.value === '') {
        return null;
      }
      if (time.value.hour > hourActual) {
        return { errorHour: true };
      }
      if (time.value.minute > minuteActual) {
        return { errorMinute: true };
      }
      return null;
    }
    return null;
  };

  /**
   * validate max char names and lastnames is correct
   *
   * @param control name of Maintainers
   * @returns error message
   */
  public maxNameCharacter(control?: AbstractControl): string {
    const character = control.get('nameUser') || control.get('nameOperator');

    if (character.value.length >= 50) {
      const maxCharacterName = this._languageService?.message('max-characters-name');
      return maxCharacterName;
    }
    return null;
  }

  /**
   * validate max char names and lastnames is correct
   *
   * @param control name of Maintainers
   * @returns error message
   */
  public maxLastNameCharacter(control?: AbstractControl): string {
    const character = control.get('lastNameUser') || control.get('lastNameOperator');
    if (character.value.length >= 49) {
      const maxCharacterLastName = this._languageService?.message('max-characters-lastname');
      return maxCharacterLastName;
    }
    return null;
  }

  /**
   * validate max char names and lastnames is correct
   *
   * @param control name of Maintainers
   * @returns error message
   */
  public maxLoginNameCharacter(control?: AbstractControl): string {
    const character = control.get('loginName');
    if (character.value.length >= 19) {
      const maxCharacterLoginName = this._languageService?.message('maxchar-loginuser');
      return maxCharacterLoginName;
    }
    return null;
  }

  /**
   * validate max char MAC address is correct
   *
   * @param control mac of Maintainers
   * @returns error message
   */
  public static maxMacCharacter(control?: AbstractControl): string {
    const character = control.get('mac') || control.get('inputMAC');
    if (character?.value?.length) {
      if (character?.value?.length > 17) {
        return 'max-characters-mac';
      }

      return null;
    } else if (character.value === null) {
      return null;
    }
    return null;
  }

  /**
   * validate max char IP address is correct
   *
   * @param control IP of Maintainers
   * @returns error message
   */
  public static maxIpCharacter(control?: AbstractControl): string {
    const character = control.get('inputIp');
    if (character.value.length >= 15) {
      return 'Maximo de caracteres para Ip';
    }
    return null;
  }

  /**
   * validate max char mtbox names is correct
   *
   * @param control name of Maintainers mtbox 10char
   * @returns error message
   */
  public maxNameMtboxCharacter(control?: AbstractControl): string {
    const character = control.get('inputMtbox');
    const maxCharacterMtbox = this._languageService?.message('max-characters-mtbox');
    if (character.value.length >= 10) {
      return maxCharacterMtbox;
    }
    return null;
  }

  /**
   * validate min char password is correct
   *
   * @param control password of Maintainers
   * @returns error message
   */
  public static minPasswordCharacter: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const character = control.get('password');

    if (character.value.length < 5) {
      return { passError: true };
    }
    return null;
  };

  /**
   * validate min char sapnumber is correct
   *
   * @param control sapNumber of Maintainers
   * @returns error message
   */
  public minAndMaxSapNumberCharacter(control: AbstractControl): { message: any; display: boolean } {
    const character = control.get('sapNumber');
    const maxCharacter = this._languageService?.message('max-characters');
    if (character.value) {
      if (character.value.length === 1 && character.value.length < 4) {
        return { message: 'Minimo 4 caracteres', display: true };
      }
      if (character.value.length < 4) {
        return { message: 'Minimo 4 caracteres', display: true };
      }
    }
    if (character.value) {
      if (character.value.length === 10) {
        return { message: maxCharacter, display: true };
      }
    }
    return { message: null, display: false };
  }

  public static validateIp: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const ipValue = control.get('newIP');
    const ipValid = ipRegex({ exact: true }).test(ipValue.value);
    if (!ipValid) {
      return { errorIp: true };
    }
    return null;
  };

  public errorCharController(control: AbstractControl): void {
    const inputControl = control.get('inputName') || control.get('nameUser') || control.get('nameOperator');
    const isValidFormatTwoSpaceBetween = validateTwoSpaceBetween(inputControl.value);
    const isValidFormatTwoSpecialChars = validateTwoSpecialChars(inputControl.value);
    const isValidFormatNoSpecialChars = validateNoSpecialChars(inputControl.value);
    const isValidFormatStartWithSpecialChar = validateStartWithSpecialCharOrSpace(inputControl.value);
    if (isValidFormatTwoSpecialChars || isValidFormatStartWithSpecialChar || isValidFormatNoSpecialChars) {
      const newName = inputControl.value.slice(0, -1);
      inputControl.setValue(newName);
    } else if (isValidFormatTwoSpaceBetween) {
      const newName = inputControl.value.slice(0, -2);
      inputControl.setValue(newName);
    }
  }

  public handleDotsController(control: AbstractControl): void {
    const inputControl = control.get('loginName');
    const isValidFormatNoStartOrEndWithDot = validateNoStartOrEndWithDot(inputControl.value);
    if (isValidFormatNoStartOrEndWithDot) {
      const newName = inputControl.value;
      inputControl.setValue(newName);
    } else if (isValidFormatNoStartOrEndWithDot === false) {
      const newName = inputControl.value.slice(0, -1);
      inputControl.setValue(newName);
    }
  }

  public errorCompoundLastNameController(control: AbstractControl): void {
    const inputControl = control.get('lastNameUser') || control.get('lastNameOperator');
    const isValidFormatTwoSpaceBetween = validateTwoSpaceBetween(inputControl.value);
    const isValidFormatTwoSpecialChars = validateTwoSpecialChars(inputControl.value);
    const isValidFormatNoSpecialChars = validateNoSpecialChars(inputControl.value);
    const isValidFormatStartWithSpecialChar = validateStartWithSpecialCharOrSpace(inputControl.value);
    if (isValidFormatTwoSpecialChars || isValidFormatStartWithSpecialChar || isValidFormatNoSpecialChars) {
      const newName = inputControl.value.slice(0, -1);
      inputControl.setValue(newName);
    } else if (isValidFormatTwoSpaceBetween) {
      const newName = inputControl.value.slice(0, -2);
      inputControl.setValue(newName);
    }
  }

  public errorControlDescription(control: AbstractControl): void {
    const inputControl = control.get('inputDescription');
    const isValidFormatTwoSpaceBetween = validateTwoSpaceBetween(inputControl.value);
    const isValidFormatTwoSpecialChars = validateTwoSpecialChars(inputControl.value);
    const isValidFormatStartWithSpecialChar = validateStartWithSpecialCharOrSpace(inputControl.value);
    if (isValidFormatTwoSpecialChars || isValidFormatStartWithSpecialChar) {
      const newName = inputControl.value.slice(0, -1);
      inputControl.setValue(newName);
    } else if (isValidFormatTwoSpaceBetween) {
      const newName = inputControl.value.slice(0, -2);
      inputControl.setValue(newName);
    }
  }

  public static errorControlMachineName(control: AbstractControl): void {
    const inputControl = control.get('machineName');
    const isValidFormatTwoSpaceBetween = validateTwoSpaceBetween(inputControl.value);
    const isValidFormatTwoSpecialChars = validateTwoSpecialChars(inputControl.value);
    const isValidFormatStartWithSpecialChar = validateStartWithSpecialCharOrSpace(inputControl.value);
    if (isValidFormatTwoSpecialChars || isValidFormatStartWithSpecialChar) {
      const newName = inputControl.value.slice(0, -1);
      inputControl.setValue(newName);
    } else if (isValidFormatTwoSpaceBetween) {
      const newName = inputControl.value.slice(0, -2);
      inputControl.setValue(newName);
    }
  }

  public static errorControlComputerName(control: AbstractControl): void {
    const inputControl = control.get('inputMtbox');
    const isValidFormatTwoSpaceBetween = validateTwoSpaceBetween(inputControl.value);
    const isValidFormatTwoSpecialChars = validateTwoSpecialChars(inputControl.value);
    const isValidFormatStartWithSpecialChar = validateStartWithSpecialCharOrSpace(inputControl.value);
    if (isValidFormatTwoSpecialChars || isValidFormatStartWithSpecialChar) {
      const newName = inputControl.value.slice(0, -1);
      inputControl.setValue(newName);
    } else if (isValidFormatTwoSpaceBetween) {
      const newName = inputControl.value.slice(0, -2);
      inputControl.setValue(newName);
    }
  }
}

/**
 * IP and MAC inputs validators funcs
 */

/**
 * Validate format ip address
 */
export function validateFormatIP(ip): boolean {
  const formatIP =
    /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

  if (ip.match(formatIP)) {
    return true;
  }
  return false;
}

/**
 * Validate format mac Address
 */
export function validateFormatMac(mac): boolean {
  return /^[a-fA-F0-9]{2}(:[a-fA-F0-9]{2}){5}$/.test(mac);
}

export function errorMac(value: any, isRepeat: boolean): string {
  const isValidFormatMac = validateFormatMac(value);

  if (!isValidFormatMac) {
    if (value !== '') {
      return 'mac-invalid';
    }
  } else if (isRepeat) {
    return 'mac-address-used';
  }
  return null;
}

export function noWhitespaceValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { whitespace: 'value is only whitespace' };
  };
}
